import { mapKeys, omitBy } from 'lodash';

import { PaginationParams } from '../models/pagination-params';

export function createPaginationSearchParams(request?: PaginationParams, filter?: Record<string, string>) {
    return new URLSearchParams(omitBy({
        search: request?.search ?? '',
        page: ((request?.pagination.pageIndex ?? 0) + 1).toString(),
        limit: request?.pagination.pageSize.toString(),
        sortBy: request?.sorting?.map((sort) => `${sort.id}:${sort.desc ? 'DESC' : 'ASC'}`).join(','),
        ...mapKeys(filter, (v, k) => `filter.${k}`)
    }, (v) => v == null) as Record<string, string>);
}
